import { __rest } from "tslib";
import * as React from 'react';
const ExternalLinkSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10,4 L10,5 L5.5,5 C5.224,5 5,5.224 5,5.5 L5,5.5 L5,14.5 C5,14.776 5.224,15 5.5,15 L5.5,15 L14.5,15 C14.776,15 15,14.776 15,14.5 L15,14.5 L15,10 L16,10 L16,14.5 C16,15.327 15.327,16 14.5,16 L14.5,16 L5.5,16 C4.673,16 4,15.327 4,14.5 L4,14.5 L4,5.5 C4,4.673 4.673,4 5.5,4 L5.5,4 L10,4 Z M16,4 L16,8 L15,8 L15,5.707 L10.707,10 L10,9.293 L14.293,5 L12,5 L12,4 L16,4 Z" })));
};
ExternalLinkSmall.displayName = 'ExternalLinkSmall';
export default ExternalLinkSmall;
//# sourceMappingURL=ExternalLinkSmall.js.map